// extracted by mini-css-extract-plugin
export var aircallIframe = "_mb-3";
export var fabContainer = "_mb-5";
export var fabRinging = "_mb-6";
export var loadingOverlay = "_mb-4";
export var pulse = "_mb-7";
export var widgetContent = "_mb-2";
export var widgetPanel = "_mb-0";
export var widgetPanelExpanded = "_mb-1";